import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getOneTraineesRequest: ['response'],
    getOneTraineesSuccess: ['response'],
    getOneTraineesFailure: ['error'],
})

export const getOneTraineesTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const getOneTraineesRequest = state => state.merge({ success: null })

const getOneTraineesSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const getOneTraineesFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_ONE_TRAINEES_REQUEST]: getOneTraineesRequest,
    [Types.GET_ONE_TRAINEES_SUCCESS]: getOneTraineesSuccess,
    [Types.GET_ONE_TRAINEES_FAILURE]: getOneTraineesFailure,
})
